define(
    [
        'core/urls',
        'moment',
        'core/browser-storage',
        'components/modal',
        'components/fake-progress',
        'components/dropdown',
        'core/iterate',
        'components/pagination',
        'components/search-field',
        'components/custom-encode-uri',
        'components/metrics',
        'components/automation-banner',
        'core/utilities',
        'components/daterangepicker-v2',
        'components/filter-box'
    ],
    function (
        urls, 
        moment, 
        browser_storage, 
        modal, 
        FakeProgress, 
        DD, 
        iterate,
        initPagination, 
        initSearchField,
        customEncodeUri,
        keyMetrics,
        automationBanner,
        utilities,
        drp,
        filterBox,
    ) 
    {
        let nodes = {
            main: document.querySelector(".sb-page.survey-results"),
            globalMetrics: document.querySelector(".metrics-header-wrap.global"),
            globalMetricsHeader: document.querySelector(".metrics-header-wrap.global header"),
            categoryMetrics: document.querySelector(".metrics-header-wrap.categories"),
            categoryMetricCards: document.querySelector(".metrics-header-wrap.categories .cards"),
            responsesHeader: document.querySelector(".page-header.responses"),
            surveySelector: document.querySelector(".survey-selector"),
            surveySelectorOptions: document.querySelectorAll(".survey-selector option"),
            settingsToggle: document.querySelector(".settings-toggle-wrap"),
            noSurveysWrap: document.querySelector(".no-results"),
            settingsPanel: document.querySelector(".settings-panel"),
            filterSettingsToggle: document.querySelector(".settings-toggle-wrap"),
            filterSettingsToggleLabel: document.querySelector(".settings-toggle-wrap .label"),
            filterStatus: document.querySelector(".filter-status"),
            filtersReset: document.querySelector(".reset-settings"),
            preserveFiltersToggle: document.querySelector("#preserveFiltersToggle"),
            dateStatus: document.querySelector(".page-header .date-range #datepicker"),
            loaderElement: document.querySelector(".marketing-loader"),
            loaderHint: document.querySelector(".marketing-loader .loader-bar-wrap_hint"),
            responsesBody: document.querySelector(".responses-table tbody"),
            resultsWrapper: document.querySelector(".responses-wrapper"),
            noResultsWrapper: document.querySelector(".no-responses"),
            resultsTable: document.querySelector(".contacts-table"),
            tableResultsWrap: document.querySelector(".table-results-wrap"),
            searchField: {
                searchField: document.querySelector(".search-response_js"),
                resetBtn: document.querySelector(".search-response-reset_js"),
                openBtn: document.querySelector(".search-response-open_js"),
                wrap: document.querySelector(".results-search-wrap_js")
            },
            pagination: {
                wrap: document.querySelector(".pagination_js"),
                page: document.querySelector(".pagination_page_js"),
                hole: document.querySelector(".pagination_hole_js")
            },
            metrics: {
                main: document.querySelector(".metrics-header-wrap.global"),
                wrap: document.querySelector(".metrics-wrap"),
                metricsContainer: document.querySelector(".metrics-wrap .metrics"),
                header: document.querySelector(".page-header.metrics"),
            },
            modals: {
                modal: document.querySelector(".modal_js"),
                close: document.querySelector(".modal-close_js"),
                content: document.querySelector(".modal-content_js"),
                title: document.querySelector(".modal-title_js"),
                bg: document.querySelector(".modal-bg_js"),
                blur: [
                    document.querySelector(".nps-responses"),
                    document.querySelector(".sidebar-nav"),
                    document.querySelector(".navigation-top")
                ]
            },
        };

        let createdModal = modal.create(nodes.modals, function () {});

        let metrics = keyMetrics.init(nodes.metrics, "survey-results");
        window.addEventListener("resize", metrics.adjustMetricsHeight);

        let currentSurvey = '';
        let pagination; 
        let isGlobal = false;
        let isAdmin = nodes.main.dataset.admin;
        let initialDateRange;
        let preserveFilters = false;
        let dataBeingRequested = false;
        let currentCategories = [];
        let storedFilters = JSON.parse(browser_storage.getItem("project-survey-filters")) || {};
        let storedDateRanges = JSON.parse(browser_storage.getItem("project-survey-date-params")) || {};

        // these are the current chosen filters - the rest of the values get populated after the getFilters() call

        let initialQueryParams = {
            q: "",
            limit: 10,
            page: "1",
            triggers: [],      
            contacts: [],
            companies: [],
            projects: [],
            members: [],
            managers:[],
            comments: "",
            sort: {
                field: "date",
                value: null,
                direction: "desc"        
            }
        }

        let queryParams = structuredClone(initialQueryParams);

        const MIN_PUBLISHABLE_SCORE = 4;

        const getCategoryScoreAverage = (categories) => {
            const scores = categories
                .map(cat => cat.value !== null && cat.value !== '' ? Number(cat.value) : null)
                .filter(val => val !== null && !isNaN(val));

            if (!scores.length) {
                return null;
            }

            return scores.reduce((sum, val) => sum + val, 0) / scores.length;
        };

        const isPublishDisabledByScore = (categories) => {
            const average = getCategoryScoreAverage(categories);
            return average === null || average < MIN_PUBLISHABLE_SCORE;
        };

        const unpublishResponse = (responseId) => fetch(urls['projects:response_publish_toggle'](responseId), {
            method: 'POST',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: 'publish=false'
        });

        // in the event that we add new filters to this page, 
        // this will add their keys to any saved filter objects in user's localstorage
        if(Object.keys(storedFilters).length !== 0) {
            let updatedStoredFilters = {};
            
            for (const [key, value] of Object.entries(storedFilters)) {
                updatedStoredFilters[key] = {...initialQueryParams, ...value}
            }
            
            browser_storage.setItem("project-survey-filters", JSON.stringify(updatedStoredFilters))
            storedFilters = updatedStoredFilters;
        }

        let initialDateParams = {
            preset: "Last 90 days",
            date: [
                moment().subtract(90, 'days').format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD'),
            ],
        }

        let dateParams = structuredClone(initialDateParams);

        let loadingScreen = new FakeProgress(
            document.querySelector(".marketing-loader .loader-bar-wrap-bar")
        );

        let populateKeyMetrics = (keyMetrics) => {
            let metricsElements = {
                average: nodes.globalMetrics.querySelectorAll(".project-score .value"),
                surveys_sent: nodes.globalMetrics.querySelectorAll(".surveys-sent .value"),
                collected_responses: nodes.globalMetrics.querySelectorAll(".responses .value"),
                response_rate: nodes.globalMetrics.querySelectorAll(".response-rate .value"),
            }

            for (const property in metricsElements) {
                metricsElements[property].forEach(element => {
                    let scoreRounded = Math.round(keyMetrics[property] * 10) / 10;
                    if(property === 'average') {
                        let scoreSentiment = utilities.generateSentiment("projects", keyMetrics[property]);
                        element.classList.remove("positive", "neutral", "negative");
                        if(scoreSentiment) element.classList.add(scoreSentiment);
                    }
                    element.innerText = scoreRounded;
                })
            }
        }

        let createTableEventListeners = () => {
            nodes.resultsTable.querySelector("thead tr").addEventListener("click", (e) => {

                let el = e.target.parentElement;
                let key = el.getAttribute("data-id");

                if (key && el.classList.contains("sortable")) {
                    let isAsc = el.classList.contains("asc");
                    
                    if(el.classList.contains("active")) {
                        queryParams.sort.direction = isAsc ? 'desc' : 'asc';
                    } else {
                        queryParams.sort.direction = 'asc';
                    }

                    if(el.classList.contains("category")) {
                        queryParams.sort.field = "category";
                        queryParams.sort.value = key * 1;
                    } else {
                        queryParams.sort.field = key;
                        queryParams.sort.value = null;
                    }
                    
                    getData(false, () => {
                        iterate(nodes.resultsTable.querySelectorAll(".sortable"), (node) => {
                            node.classList.remove("asc");
                            node.classList.remove("desc");
                            node.classList.remove("active");
                        });

                        el.classList.add("active");

                        if (queryParams.sort.direction === "asc") {
                            el.classList.add("asc");
                        } else {
                            el.classList.add("desc");
                        }
                    });
                }
            });
        }

        let populateTableHeader = (categories) => {
            let tableHeader = document.querySelector(".table-results-wrap table thead");
            let categoryElements = '';  

            categories.forEach(category => {
                categoryElements += `
                        <td class="score-column sortable category asc" data-id="${category.id}">
                            <span class="wrap-text">
                                ${category.name}
                                <img class="select-arrow-icon" src="/static/icons/down.svg" alt="">
                            </span>
                        </td>
                    `;
            });

            let periodColumn = `
                <td class="period sortable asc" data-id="trigger">
                    <span class="wrap-text">
                        Survey Period <img class="select-arrow-icon" src="/static/icons/down.svg" alt="">
                    </span>
                </td>
            `;

            let companyColumn = `
                <td class="company sortable asc" data-id="company">
                    <span class="wrap-text">
                        Company <img class="select-arrow-icon" src="/static/icons/down.svg" alt="">
                    </span>
                </td>
            `;

            let projectColumn = `
                <td class="project sortable asc" data-id="project">
                    <span class="wrap-text">
                        Project <img class="select-arrow-icon" src="/static/icons/down.svg" alt="">
                    </span>
                </td>
            `;

            let projectManagerColumn = `
                <td class="managers sortable asc" data-id="managers">
                    <span class="wrap-text">
                        Project Managers <img class="select-arrow-icon" src="/static/icons/down.svg" alt="">
                    </span>
                </td>
            `;

            let teamMemberColumn = `
                <td class="members sortable asc" data-id="members">
                    <span class="wrap-text">
                        Team Members <img class="select-arrow-icon" src="/static/icons/down.svg" alt="">
                    </span>
                </td>
            `;

            let publishColumn = `
                <td class="publish-comment sortable asc" data-id="has_marketing_permissions">
                    <span class="wrap-text">
                        Publish Comment <img class="select-arrow-icon" src="/static/icons/down.svg" alt="">
                    </span>
                </td>
            `;

            let deleteColumn = `
                <td class="delete-comment center" data-id="delete_response">
                    <span class="wrap-text">
                        Controls
                    </span>
                </td>
            `;

            let customColumns = periodColumn;

            if(isGlobal) customColumns = companyColumn + projectColumn;

            tableHeader.innerHTML = `
                <tr>
                    <td class="name sortable asc" data-id="contact">
                        <span class="wrap-text">
                            Contact name <img class="select-arrow-icon" src="/static/icons/down.svg" alt="">
                        </span>
                    </td>
                    <td class="date sortable active asc" data-id="date">
                        <span class="wrap-text">
                            Date <img class="select-arrow-icon" src="/static/icons/down.svg" alt="">
                        </span>
                    </td>
                    ${customColumns}
                    ${projectManagerColumn}
                    ${teamMemberColumn}
                    ${categoryElements}
                    ${publishColumn}
                    ${isAdmin === 'True' ? deleteColumn : ''}
                </tr>
            `;
            createTableEventListeners();
        }

        let populateCategoryMetrics = (categories) => {
            nodes.categoryMetricCards.innerHTML = '';
            categories.forEach(category => {
                let scoreRounded = (Math.round(category.average * 10) / 10);
                let sentiment = utilities.generateSentiment("projects", category.average);
                
                nodes.categoryMetricCards.innerHTML += `
                    <div class="card">
                        <div class="card__title">${category.name}</div>
                        <div class="card__main-score value ${sentiment}">${scoreRounded}</div>
                    </div>
                `;
            })
        }

        let populateResponses = (responses) => {
            nodes.responsesBody.innerHTML = '';
            let tableRows = '';

            responses.forEach((response, i) => {
                let evenOdd = (i % 2 === 0) ? 'even' : 'odd';
                let surveyPeriod = response.trigger.phase ? response.trigger.phase : "Project Status";
                let surveyPeriodStatus = response.trigger.status;
                let surveyPeriodOutput = `<div class="chip light">${surveyPeriod}</div>
                                            <div class="chip light">${surveyPeriodStatus}</div>`;
                
                let categoryScores = '';
                let commentRow = '';
                let managers = '';
                let members = '';
                let colspan = isGlobal ? response.categories.length + 8 : response.categories.length + 7;
                let commentScoreTotal = 0;

                response.categories.forEach(category => {
                    let sentiment = utilities.generateSentiment("projects", category.value);
                    let categoryScore = category.value ? category.value : "—";
                    categoryScores += `<td class="center score-column"><div class="score ${sentiment}">${categoryScore}</div></td>`
                    commentScoreTotal += category.value;
                });

                members = response.members.join(", ");
                managers = response.managers.join(", ");

                if(response.comment && response.comment !== '') {
                    let truncateClass = '';
                    let moreLessElement = '';
                    if(response.comment.length > 100) {
                        truncateClass = "truncate";
                        moreLessElement = `<div class="show-comment">more</div>`
                    }

                    commentRow = `
                        <tr class="comment-row">
                            <td colspan="${colspan}" class="comment-row">
                                <div class="comment-wrap">
                                    <div class="comment ${truncateClass}">
                                        "${response.comment}"
                                    </div>
                                    ${moreLessElement}
                                </div>
                            </td>
                        </tr>
                    `;
                }

                let customColumns = `<td class="survey-period">${surveyPeriodOutput}</td>`;

                if(isGlobal) {
                    customColumns = `
                        <td class="company">${response.company}</td> 
                        <td class="project">${response.project}</td>    
                    `
                }

                let publishToggle = "-";
                const hasComment = response.comment && response.comment !== '';

                if (!hasComment) {
                    let commentTooltip = '<div class="sb-tooltip no-comment">Comment not provided</div>';
                    publishToggle = `–${commentTooltip}`;
                } else if (!Boolean(response.has_marketing_permissions)) {
                    let publishPermissionTooltip = '<div class="sb-tooltip">Marketing permission not provided</div>';
                    publishToggle = `–${publishPermissionTooltip}`;
                } else {
                    let publishId = response.comment_response_id;
                    let checked = Boolean(response.is_published) ? "checked" : "";
                    let adminDisabled = isAdmin === "True" ? "" : "disabled";
                    let publishDisabledByScore = isPublishDisabledByScore(response.categories);
                    let scoreTooltip = publishDisabledByScore ? '<div class="sb-tooltip">Only response averaging 4 or higher with marketing permission can be published to the widget</div>' : '';

                    publishToggle = `
                        <div class="mini-toggle ${adminDisabled} ${publishDisabledByScore ? 'disabled' : ''}">
                            <input id="publishComment_${publishId}" class="publish-toggle" type="checkbox" data-response-id="${publishId}" data-publish-eligible="${!publishDisabledByScore}" ${adminDisabled || publishDisabledByScore ? 'disabled' : ''} ${!publishDisabledByScore && checked ? 'checked' : ''}>
                            <label for="publishComment_${publishId}"></label>
                        </div>
                        ${scoreTooltip}
                    `;
                }

                let publishComment = `
                    <td class="publish-comment tooltip-wrap">
                        ${publishToggle}
                    </td> `;

                let deleteButton = `
                    <td class="remove-response-wrap">
                        <div class="flex-wrapper">
                            <div
                                data-id="${response.deployment_id}"
                                data-categories='${utilities.sanitizeData(JSON.stringify(response.categories))}'
                                data-contact="${utilities.sanitizeData(response.contact.first_name)} ${utilities.sanitizeData(response.contact.last_name)}"
                                data-has-comment="${response.comment ? 'true' : 'false'}"
                                role="button"
                                class="btn btn-primary edit-response icon glyphicons glyphicons-pencil">
                            </div>
                            <div
                                data-id="${response.deployment_id}"
                                data-contact="${utilities.sanitizeData(response.contact.first_name)} ${utilities.sanitizeData(response.contact.last_name)}"
                                role="button"
                                class="btn btn-danger remove-response icon glyphicons glyphicons-remove">
                            </div>
                        </div>
                    </td>
                `
                
                tableRows += `
                    <tr class="${evenOdd}" role="row" data-response-id=${response.comment_response_id} data-deployment-id="${response.deployment_id}">
                        <td class="name">${utilities.sanitizeData(response.contact.first_name)} ${utilities.sanitizeData(response.contact.last_name)}</td>
                        <td class="date">${moment(response.date).format('DD MMM YYYY')}</td>
                        ${customColumns}
                        <td class="managers">${managers === '' ? '-' : managers}</td>
                        <td class="members">${members === '' ? '-' : members}</td>
                        ${categoryScores}
                        ${publishComment}
                        ${isAdmin === 'True' ? deleteButton : ''}
                    </tr>
                    ${commentRow}
                `;
            })

            nodes.responsesBody.innerHTML = tableRows;

            nodes.responsesBody.querySelectorAll(".comment-wrap .show-comment").forEach(element => {
                element.addEventListener("click", (event) => {
                    let comment = event.target.previousElementSibling;

                    if(element.classList.contains("active")) {
                        element.classList.remove("active");
                        element.innerHTML = "more";
                        comment.classList.remove("open");
                        comment.classList.add("truncate");
                    } else {
                        element.classList.add("active");
                        element.innerHTML = "less";
                        comment.classList.add("open");
                        comment.classList.remove("truncate");
                    }
                })
            })

            nodes.responsesBody.querySelectorAll(".publish-comment input").forEach(input => {
                input.addEventListener("change", () => {
                    if (input.dataset.publishEligible === 'false') {
                        input.checked = false;
                        return;
                    }

                    let publish = "false";
                    let id = input.dataset.responseId;

                    if(input.checked) {
                        publish = "true"
                    }

                    fetch(urls['projects:response_publish_toggle'](id), {
                        method: 'POST',
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                        body: `publish=${publish}`
                    });
                })
            });

            nodes.responsesBody.querySelectorAll(".edit-response").forEach(el => {
                el.addEventListener("click", () => {
                    let deploymentId = el.getAttribute("data-id");
                    let categories = JSON.parse(el.getAttribute("data-categories"));

                    let nameById = Object.fromEntries(currentCategories.map(c => [c.id, c.name]));

                    let formRows = categories.map((cat, i) => {
                        let name = nameById[cat.id] || `Category ${cat.id}`;
                        let zIndex = 15 - i;
                        let options = [1, 2, 3, 4, 5].map(n =>
                            `<option value="${n}" ${cat.value === n ? 'selected' : ''}>${n}</option>`
                        ).join('');

                        return `
                            <div class="edit-response-row">
                                <label class="edit-response-label">${utilities.sanitizeData(name)}</label>
                                <div class="custom-select" style="z-index: ${zIndex}">
                                    <select id="edit-response-category-${cat.id}" class="category-score-select" data-category-id="${cat.id}">
                                        <option value="">—</option>
                                        ${options}
                                    </select>
                                    <img src="/static/icons/select-arrow.svg" alt="">
                                </div>
                            </div>
                        `;
                    }).join('');

                    let content = `
                        <div class="edit-response-form">
                            ${formRows}
                            <div class="alert alert-danger hide">Removing all scores will cause this response to be deleted. This action cannot be undone.</div>
                            <button class="button-primary save-edit-response" data-id="${deploymentId}">Save</button>
                        </div>
                    `;

                    let contactName = el.getAttribute("data-contact");
                    let hasComment = el.getAttribute("data-has-comment") === "true";
                    let template = document.querySelector(".modal-template-edit-response_js");
                    createdModal.open({
                        class: template.getAttribute("data-class"),
                        content: content,
                        title: `Update responses from `,
                    }, (modalEl) => {
                        let nameSpan = document.createElement('span');
                        nameSpan.textContent = `${contactName}`;
                        nameSpan.classList.add('modal-contact-name');
                        modalEl.querySelector('.modal-title_js').appendChild(nameSpan);

                        let warningEl = modalEl.querySelector('.alert-danger');
                        let checkAllBlank = () => {
                            let allBlank = [...modalEl.querySelectorAll('.category-score-select')].every(s => s.value === '');
                            warningEl.classList.toggle('hide', !(allBlank && !hasComment));
                        };

                        modalEl.querySelectorAll(".edit-response-form .custom-select").forEach(selectWrapper => {
                            DD(selectWrapper, () => { checkAllBlank(); });
                        });
                        modalEl.querySelector('.save-edit-response').addEventListener('click', () => {
                            let categorySelects = modalEl.querySelectorAll('.category-score-select');
                            let updatedCategories = [...categorySelects].map(select => ({
                                id: select.getAttribute('data-category-id'),
                                value: select.value,
                            }));
                            const row = document.querySelector(`tr[data-deployment-id="${deploymentId}"]`);
                            const publishToggle = row && row.querySelector('.publish-toggle');
                            const wasPublished = publishToggle && publishToggle.checked;
                            const shouldUnpublish = wasPublished && isPublishDisabledByScore(
                                updatedCategories.map(cat => ({
                                    value: cat.value ? parseInt(cat.value, 10) : null
                                }))
                            );

                            createdModal.close();

                            const saveResponseEdit = () => fetch(urls['projects:response_edit'](deploymentId), {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                    deployment_id: deploymentId,
                                    categories: updatedCategories,
                                }),
                            }).then(() => {
                                getData();
                            });

                            if (shouldUnpublish) {
                                unpublishResponse(publishToggle.dataset.responseId).finally(saveResponseEdit);
                            } else {
                                saveResponseEdit();
                            }
                        });
                    });
                });
            });

            nodes.responsesBody.querySelectorAll(".remove-response").forEach(btn => {
                btn.addEventListener("click", () => {
                    let id = btn.getAttribute("data-id");
                    let contactName = btn.getAttribute("data-contact");
                    let template = document.querySelector(".modal-template-delete-response_js");
                    createdModal.open({
                        class: template.getAttribute("data-class"),
                        content: template.innerHTML,
                        title: `Delete response from `,
                    }, (modalEl) => {
                        let nameSpan = document.createElement('span');
                        nameSpan.textContent = `${contactName}?`;
                        nameSpan.classList.add('modal-contact-name');
                        modalEl.querySelector('.modal-title_js').appendChild(nameSpan);
                        modalEl.querySelector(".confirm-delete-response").addEventListener("click", () => {
                            createdModal.close();
                            deleteResponse(id);
                        });
                    });
                });
            });
        }

        let deleteResponse = (id) => {
            let row = document.querySelector(`tr[data-deployment-id="${id}"`);
            let commentRow = row.nextElementSibling && row.nextElementSibling.classList.contains("comment-row") ? row.nextElementSibling : null;
            row.classList.add("deleted");
            if(commentRow) commentRow.classList.add("deleted");
            
            fetch(urls["projects:response_delete"](id), {
                method: 'DELETE',
            }).then(() => {
                row.remove();
                if(commentRow) commentRow.remove();
                getData();
            })
        }

        let getData = async (isPageLoad, callback, reRenderFilters) => {
            loadingScreen.reset();
            nodes.loaderElement.classList.remove("disabled");
            loadingScreen.startLoading(15);

            if(preserveFilters) {  
                let storedQueryParams = browser_storage.getItem("project-survey-filters", currentSurvey);  
                let storedDateParams =  browser_storage.getItem("project-survey-date-params", currentSurvey)       
                queryParams = storedQueryParams ? JSON.parse(storedQueryParams) : structuredClone(initialQueryParams);
                dateParams = storedDateParams ? JSON.parse(storedDateParams) : structuredClone(initialDateParams);
            }

            let response = await fetch(urls['projects:responses_data'](currentSurvey, dateParams.date[0], dateParams.date[1]), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(queryParams)
            })

            let data = await response.json();

            currentCategories = data.categories;

            // update this with proper global flag from backend
            isGlobal = data.filter_options.companies ? true : false;

            if(isPageLoad || reRenderFilters) {
                filterBox.create(
                    'project-survey', // page prefix
                    null, // filter data endpoint
                    (qp, dp) => { // on change
                        if(!preserveFilters) {
                            queryParams = qp;
                            dateParams = dp;
                        }
                        getData(false);
                    },
                    null, // on ready
                    data.filter_options, // filter data
                    currentSurvey
                );
                
                populateTableHeader(data.categories);
            }

            populateKeyMetrics(data.key_metrics);

            setTimeout(() => {
                utilities.setSettingsHeight(nodes);
                metrics.adjustMetricsHeight();
            }, 100);

            // update global score card title
            let projectScoreCardTitle = nodes.globalMetrics.querySelector(".project-score .card__title");
            projectScoreCardTitle.innerText = isGlobal ? "Overall Template Score" : "Overall Project Score";

            populateCategoryMetrics(data.categories);
            
            pagination.set(data.page_info);

            if(!data.responses.length) {
                nodes.tableResultsWrap.classList.add("hide");
                nodes.noResultsWrapper.classList.remove("hide");
            } else {
                populateResponses(data.responses);
                nodes.tableResultsWrap.classList.remove("hide");
                nodes.noResultsWrapper.classList.add("hide");
            }

            browser_storage.setItem("last-visited-survey", currentSurvey);

            if(callback) callback();

            nodes.loaderElement.classList.add("disabled");
            loadingScreen.loadFinish();

            dataBeingRequested = false;
        }

        let createEventListeners = () => {
            nodes.globalMetricsHeader.addEventListener("click", (event) => {
                if(browser_storage.getItem("survey-results-stats-collapse") === "false") {
                    browser_storage.setItem("survey-results-stats-collapse", "true");
                    nodes.globalMetrics.classList.add("collapse");
                } else {
                    browser_storage.setItem("survey-results-stats-collapse", "false");
                    nodes.globalMetrics.classList.remove("collapse");
                }
            })
        }

        const csvDownload = () => {
            const classes = {
                CSV: {
                    btn: ".csv-download",
                    filter: ".nps-csv-download-filters_js",
                    noFilter: ".nps-csv-download-no-filters_js",
                    modalContent: ".modal-template-csv_js"
                },
            };
            //button for download csv modal
            const downloadCSVBtn = document.querySelector(classes.CSV.btn);

            downloadCSVBtn.addEventListener("click", function () {
                const content = document.querySelector(classes.CSV.modalContent);
                const title = content.getAttribute("data-title");
                const className = content.getAttribute("data-class");

                createdModal.open({
                    //set a wrap class for a modal
                    class: className,
                    //set content for a modal
                    content: content.innerHTML,
                    //set title for a modal
                    title: title
                }, () => {
                    //Bind events when DOM loaded at the modal screen;
                    let downloadFilter = document.querySelector(classes.CSV.filter);
                    let downloadNoFilter = document.querySelector(classes.CSV.noFilter);
                    downloadFilter.addEventListener("click", downloadCSV);
                    downloadNoFilter.addEventListener("click", downloadCSV);
                });
            });

            //function that called when you click how you want to download CSV
            const downloadCSV = async (event) => {
                const url = urls['projects:responses_csv'](currentSurvey);

                try {
                    $.ajax({
                        url: url,
                        type: 'POST',
                        contentType: "application/json; charset=utf-8",
                        data: JSON.stringify(event.target.getAttribute("data-all") ? initialQueryParams : queryParams)
                    }).done((data) => {
                        let blob = new Blob([data], {type: 'text/csv'});
                        let date = new Date()
                        let filename = `Project Survey Results - SmileBack - ${date.toISOString().split('T')[0]}`;
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                            window.navigator.msSaveOrOpenBlob(blob, filename);
                        } else {
                            let link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.download = filename;
                            link.click();
                        }
                    });

                } catch (error) {
                    console.error(error.message);
                }
                createdModal.close();
            }
        }

        return {
            init: function () {
                automationBanner();
                csvDownload();

                window.addEventListener("resize", () => {
                    utilities.setSettingsHeight(nodes)
                });

                if(browser_storage.getItem("survey-results-stats-collapse") === "false") {
                    nodes.globalMetrics.classList.add("no-transition");
                    nodes.globalMetrics.classList.remove("collapse");
                    nodes.globalMetrics.classList.remove("no-transition");
                }

                if(browser_storage.getItem("preserve-project-survey-filters") === "true") {
                    nodes.preserveFiltersToggle.checked = true;
                    preserveFilters = true;
                }

                // check for active surveys
                if(nodes.surveySelectorOptions.length) {
                    let DDSurveySelector = DD(nodes.surveySelector, (value) => {
                        currentSurvey = value;
                        searchField.reset();                        
                        filterBox.destroy();

                        let storedQueryParams = browser_storage.getItem("project-survey-filters", currentSurvey);      
                        queryParams = storedQueryParams ? JSON.parse(storedQueryParams) : structuredClone(initialQueryParams);
                        utilities.updateFilterStatus(queryParams);
                        
                        getData(null, null, true);

                        dataBeingRequested = true;
                    });

                    // check for survey ID in url
                    let passedID = utilities.getQueryStringVariable("id");
                    // get last visited survey or first survey in list
                    currentSurvey = passedID ? passedID : browser_storage.getItem("last-visited-survey");

                    let surveyExists = false;
                    // check if saved survey still exists
                    nodes.surveySelectorOptions.forEach(option => {
                        if(option.value === currentSurvey) {
                            surveyExists = true;
                        }
                    })

                    if(currentSurvey && currentSurvey.length && surveyExists) {
                        if(storedDateRanges && storedDateRanges[currentSurvey]) {
                            dateParams = storedDateRanges[currentSurvey];
                        }
                        DDSurveySelector.chooseOption(currentSurvey);
                    } else {
                        currentSurvey = nodes.surveySelectorOptions[0].value;
                    }

                    //init Pagination
                    pagination = initPagination(nodes.pagination, function (value) {
                        queryParams.page = value;
                        getData();
                    }, queryParams);

                    let releaseSearch = () => {
                        nodes.searchField.searchField.disabled = false;
                        nodes.searchField.searchField.focus();
                    }

                    let searchField = initSearchField(nodes.searchField, function (value) {
                        nodes.searchField.searchField.disabled = true;
                        queryParams["q"] = customEncodeUri(value);
                        
                        queryParams.page = "1";
                        getData(false, () => {
                            releaseSearch();
                        });

                    }, {next: queryParams.q});

                    let limitNode = document.querySelector(".nps-responses-custom-limit_js");
                    limitNode.querySelector("select").value = queryParams.limit + "";

                    let DDReset = DD(limitNode, (value) => {
                        queryParams["limit"] = value;
                        queryParams.page = "1";
                        getData();
                    });
                } else {
                    nodes.noSurveysWrap.classList.remove("hide");
                }      
                
                queryParams.page = '1';

                let presetDateRange = drp.getDateParams();
                dateParams = presetDateRange;
                initialDateRange = presetDateRange;

                createEventListeners();
                getData(true);
                dataBeingRequested = true;
            }
        }
    }
);